import { Box, Flex, TextV2 } from '@withjoy/joykit';
import React, { useState } from 'react';
import { ChecklistToDoMark } from '../ChecklistToDoMark';
import { ChevronRight } from '@withjoy/joykit/icons';
import { animationTransition } from '@shared/utils/animationTransition';

interface ChecklistItemProps {}

export const ChecklistItem: React.FC<ChecklistItemProps> = ({ children }) => {
  const [completed, setCompleted] = useState(false); // Placeholder
  const [remindMeLater /*, setRemindMeLater*/] = useState(false); // Placeholder for https://withjoy.atlassian.net/browse/CORE-5088

  return (
    <Flex
      borderTop={'1px solid'}
      borderTopColor={'mono3'}
      padding={6}
      alignItems={'center'}
      cursor={'pointer'}
      role={'button'}
      backgroundColor={'white'}
      transition={animationTransition('background-color')}
      __css={{
        '&:hover:not(:has(.checkmark:hover))': {
          backgroundColor: 'mono2'
        },
        '&:hover:not(:has(.checkmark:hover)) .checklist-content__title': {
          color: 'linkHover'
        },
        '&:active:not(:has(.checkmark:active))': {
          backgroundColor: 'mono3'
        },
        '&:active:not(:has(.checkmark:active)) .checklist-content__title': {
          color: 'linkActive'
        },
        '&:has(.checkmark:hover) .checklist-content__title': {
          textDecoration: 'line-through'
        },
        '&:has(.checkmark:hover) .checklist-content__subtitle': {
          opacity: 0
        },
        '&:has(.checkmark:hover) .checklist-content__children': {
          opacity: 0,
          maxWidth: 0
        },
        '&:has(.checkmark:hover) .checklist-content': {
          transform: 'translateY(13px)'
        },
        '&:has(.checkmark:hover) .checklist-chevron': {
          opacity: 0,
          transform: 'translateY(13px)'
        },
        ...(!remindMeLater && {
          '&:hover:not(:has(.checkmark:hover)) .checklist-chevron': {
            opacity: 1,
            transform: 'translateY(0)'
          }
        })
      }}
    >
      {/* Checkmark */}
      <Box className={'checkmark'}>
        <ChecklistToDoMark completed={completed} toggleCompleted={() => setCompleted(!completed)} />
      </Box>
      {/* Content */}
      <Flex
        flexGrow={1}
        paddingLeft={4}
        className={'checklist-content'}
        transition={animationTransition('transform')}
        transform={completed || remindMeLater ? 'translateY(13px)' : 'translateY(0)'}
        overflow={remindMeLater ? 'visible' : 'hidden'}
        maxWidth={'calc(100% - 40px)'}
      >
        <Flex flexDirection={'column'} rowGap={3} overflow={'hidden'} flexGrow={1}>
          <TextV2
            typographyVariant={'hed1'}
            className={'checklist-content__title'}
            textDecoration={completed ? 'line-through' : 'none'}
            transition={animationTransition('color')}
            overflow={'hidden'}
            whiteSpace={'nowrap'}
            textOverflow={'ellipsis'}
          >
            Review Event Details
          </TextV2>
          <TextV2
            typographyVariant={'label2'}
            color={'mono10'}
            className={'checklist-content__subtitle'}
            opacity={completed || remindMeLater ? 0 : 1}
            transition={animationTransition('opacity')}
            overflow={'hidden'}
            whiteSpace={'nowrap'}
            textOverflow={'ellipsis'}
          >
            Who, Where, When, Because{' '}
            <span role="img" aria-label="Heart">
              💖
            </span>
          </TextV2>
        </Flex>
        {children && (
          <Box className={'checklist-content__children'} opacity={completed ? 0 : 1} maxWidth={'100%'} transition={animationTransition('opacity', 'max-width')}>
            {children}
            {/* Placeholder for https://withjoy.atlassian.net/browse/CORE-5088 */}
            {/* <Box
              width={remindMeLater ? '150px' : '30px'}
              _hover={{
                width: '150px'
              }}
              backgroundColor={'mono6'}
              transition={animationTransition('width')}
              onClick={() => setRemindMeLater(!remindMeLater)}
            /> */}
          </Box>
        )}
      </Flex>
      {/* Chevron */}
      <Flex
        className={'checklist-chevron'}
        paddingLeft={3}
        opacity={completed || remindMeLater ? 0 : 1}
        transition={animationTransition('opacity', 'transform')}
        transform={completed || remindMeLater ? 'translateY(13px)' : 'translateY(0)'}
      >
        <ChevronRight />
      </Flex>
    </Flex>
  );
};
